import { render, staticRenderFns } from "./CatalogProductIdealPath.vue?vue&type=template&id=2730f825&"
import script from "./CatalogProductIdealPath.vue?vue&type=script&lang=js&"
export * from "./CatalogProductIdealPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports